/**
 * contiene la información para el manejo de adjuntos.
 */
export const defaulAdjunto = () => {
    return {
        id_adjunto: null,
        idioma: null,
        tipo: null,
        estado_fds: null,
        sistema: 'no',
        observacion: '',
        avatar: '',
        fecha: null,
        cumple_decreto: null,
        activo: 1,
        filtroEmpresas: null,
        paginador: 10,
        verPaginador: false,
        asignaciones: [],
        asignaciones_ori: [],
        id_producto: '',
        no_cumple: 1,
        observacion_no_cumple: '',
        slq_location_id: null,
        in_use: null
    }
}

export const defaultFiltro = () => {
    return {
        page: 1,
        perPage: 10,
        estado: [1],
        observacion: '',
        tipo: null,
        idioma: null,
        all:0
    }
}

export const defaultSelectedTodos = () => {
    return {
        activo: 1,
        asignado: true,
        id: 0,
        id_adjunto: 0,
        nombre: "TODAS",
        todo: false,
    }

}

export const dataInitialFilter = () => {
    return {
        page: 1,
        perPage: 10,
        status: [1],
        description: '',
        type: null,
        language: null
    }
}


export const defaultFilterHistRev = () => {
    return {
        prod_attachment_id: null,
        page: 1,
        per_page: 5,
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedAdjunto: defaulAdjunto(),
    modal:{
        ver: false
    },
    adjunto_cargado: false,
    filtro: defaultFiltro(),
    adjuntosProcesados: [],
    adjuntosArchivo: [],
    idiomas: [],
    tipos: [],
    estados_fds: [],
    Actualiza: null,
    adj: '',
    listadoAdj: [],
    adjuntos: [],
    adjuntoInactivo:[],
    id_empresa: '',
    urlDescarga: '',
    id_producto: '',
    total_activo:'',
    total_inactivo:'',
    todosAsignados: false,
    todos:defaultSelectedTodos(),
    accion: 'Crear',
    // Adjuntos del producto
    attachments: [],
    // Parametros del filtro
    filter: dataInitialFilter(),
    totalTe: {
        te_gen: 0,
        te_adj: 0,
    },
    attachmentsFdsMsds: [],
    attachmenteCreated: null,
    historicalRevisionAttach: { data: [], total: 0 },
    filterHistRev: defaultFilterHistRev(),
    loaderFormRevAdj: false,
}
